import axios from 'axios';
import { URLS } from '@constants/urls';
import api from '@helpers/api';
import { encodeQuery } from '@pentabd/ui';
import { InitialSettingsResponseType } from '@type/dashboard';

export const getInitialSettings = (() => {
  const cancelToken = axios.CancelToken;
  let source = cancelToken.source();
  let isRequestInProcess = false;

  return async (
    election_schedule_id: string | number,
  ): Promise<{ data: InitialSettingsResponseType[] }> => {
    if (isRequestInProcess) {
      source.cancel();
      source = cancelToken.source();
    }

    isRequestInProcess = true;

    return api
      .get(
        encodeQuery(URLS.GET_INITIAL_SETTINGS, {
          election_schedule_id,
        }),
      )
      .then((response) => {
        return { data: response.data };
      })
      .finally(() => {
        isRequestInProcess = false;
      });
  };
})();
